import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { useAppContext } from 'app/AppContext';

import { fetchArray } from 'entity';
import Inscricao from 'entity/Inscricao';
import Rodada from 'entity/Rodada'

import DataTable from 'components/DataTable'

import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function InscricaoForm() {
    const navigate = useNavigate();
    const { useSetTitle, setActionsView } = useAppContext();
    const [inscricoes, setInscricoes] = useState([]);
    const [searchNomeEmpresa, setSearchNomeEmpresa] = useState("");
    const [searchStatus, setSearchStatus] = useState("TODOS")
    const [searchStatusEvento, setSearchStatusEvento] = useState("TODOS")
    const [searchNomeRodada, setSearchNomeRodada] = useState("");
    const [filteredInscricoes, setFilteredInscricoes] = useState([]);
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const actions = [
            {
                uid: "novoForm",
                text: "Novo",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/inscricao");
                },
            },

        ];

        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
    }, [navigate, setActionsView]);

    useSetTitle("INSCRIÇÕES");

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        if (inscricoes.length === 0) {
            let result = await fetchArray(Inscricao.getAll());

            let rodadas = await fetchArray(Rodada.getAll())
            for (let i = 0; i < result.length; i++) {
                for (let j = 0; j < rodadas.length; j++) {
                    if (result[i].rodada.uid === rodadas[j].uid) {
                        result[i].rodada = rodadas[j]
                    }
                }
            }

            result = result.map(i => {
                i.rodada.nome = i.rodada?.nome?.toUpperCase()
                i.empresa.nomeFantasia = i.empresa?.nomeFantasia?.toUpperCase()
                return i
            })

            setInscricoes([{}, ...result]);
            setFilteredInscricoes([{}, ...result]);
            setLoading(false)
        }
    }, [inscricoes]);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    useEffect(() => {
        setFilteredInscricoes(
            inscricoes.filter(inscricao => {
                let nome = false, rodada = false, status = false, statusEvento = false

                if (inscricao.empresa?.nomeFantasia?.toUpperCase().includes(searchNomeEmpresa.toUpperCase())) {
                    nome = true
                }
                if (inscricao.rodada?.nome?.toUpperCase().includes(searchNomeRodada.toUpperCase())) {
                    rodada = true
                }
                if (searchStatus === "TODOS") {
                    status = true
                } else if (inscricao.status?.toUpperCase().includes(searchStatus.toUpperCase())) {
                    status = true
                }
                if (searchStatusEvento === "TODOS") {
                    console.log("TODOS")
                    statusEvento = true
                } else if (inscricao.statusEvento?.toUpperCase().includes(searchStatusEvento.toUpperCase())) {
                    console.log("searchStatusEvento", searchStatusEvento)
                    statusEvento = true
                }

                return nome && rodada && status && statusEvento
            })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchNomeEmpresa, searchNomeRodada, searchStatus, searchStatusEvento])

    return (

        <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
            <Box sx={{ mt: 0 }}>

                <Accordion sx={{ boxShadow: 3, mb: 1 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                    >
                        <Typography>FILTRO</Typography>
                    </AccordionSummary>
                    <AccordionDetails>

                        <TextField
                            sx={{ width: "100%", my: 2 }}
                            id="nomeRodadaTextField"
                            label="NOME DA RODADA"
                            variant="standard"
                            onChange={e => setSearchNomeRodada(e.target.value)}
                            value={searchNomeRodada}
                            inputProps={{ style: { textTransform: "uppercase" } }}
                        />
                        <TextField
                            sx={{ width: "100%", my: 2 }}
                            id="nomeEmpresaTextField"
                            label="NOME DA EMPRESA"
                            variant="standard"
                            onChange={e => setSearchNomeEmpresa(e.target.value)}
                            value={searchNomeEmpresa}
                            inputProps={{ style: { textTransform: "uppercase" } }}
                        />

                        <FormControl variant="standard" fullWidth sx={{ my: 2 }}>
                            <InputLabel>STATUS</InputLabel>
                            <Select
                                value={searchStatus}
                                label="STATUS"
                                onChange={e => setSearchStatus(e.target.value)}
                            >
                                <MenuItem value={"INSCRITO"}>INSCRITO</MenuItem>
                                <MenuItem value={"CANCELADO"}>CANCELADO</MenuItem>
                                <MenuItem value={"TODOS"}>TODOS</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl variant="standard" fullWidth sx={{ my: 2 }}>
                            <InputLabel>STATUS EVENTO</InputLabel>
                            <Select
                                value={searchStatusEvento}
                                label="STATUS EVENTO"
                                onChange={e => setSearchStatusEvento(e.target.value)}
                            >
                                <MenuItem value={"INSCRITO"}>INSCRITO</MenuItem>
                                <MenuItem value={"CHECKIN"}>CHECKIN</MenuItem>
                                <MenuItem value={"CHECKOUT"}>CHECKOUT</MenuItem>
                                <MenuItem value={"AUSENTE"}>AUSENTE</MenuItem>
                                <MenuItem value={"PENDENTE"}>PENDENTE</MenuItem>
                                <MenuItem value={"DESISTIU"}>DESISTIU</MenuItem>
                                <MenuItem value={"TODOS"}>TODOS</MenuItem>
                            </Select>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <DataTable
                columns={Inscricao.searchColumns}
                rows={filteredInscricoes}
                onRowClick={row => navigate("/inscricao?uid=" + row.id)}
                components={{
                    LoadingOverlay: CircularProgress,
                }}
                loading={loading}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                }}
            />
        </Box>
    )
}